import config from 'devextreme/core/config';
import { licenseKey } from '~/app/config/devextreme/devextreme-license-key';
import { PreloadAllModules, provideRouter, withPreloading } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiInterceptor } from '~/app/core/services/interceptor/ApiInterceptor';
import { routes } from '~/app/app.routes';
import { AppComponent } from '~/app/app.component';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { importProvidersFrom } from '@angular/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideEnvironmentConfiguration } from '@softwarehaus/util-angular-configuration';
import { NAPOLEON_ENVIRONMENTS_CONFIGURATION } from '~/app/config/environments-configuration';
import { AgmCoreModule } from 'ng-agm-core-lib';

config({ licenseKey, defaultCurrency: 'EUR' });

const providers = [
  provideRouter(routes, withPreloading(PreloadAllModules)),
  provideHttpClient(withInterceptors([apiInterceptor])),
  provideEnvironmentConfiguration(NAPOLEON_ENVIRONMENTS_CONFIGURATION),
  provideTranslateService({
    lang: 'de',
    fallbackLang: 'en',
    loader: provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: '.json',
    }),
  }),

  importProvidersFrom(
    AgmCoreModule.forRoot({
      apiKey: 'AIzaSyB6CEBmKSrqK3johbyxFQEhscpQ66B8NtQ',
      libraries: ['places'],
    }),
  ),
];

bootstrapApplication(AppComponent, { providers }).catch((err) => console.error(err));
